"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStorageEnum = exports.StorageEnum = void 0;
var StorageEnum;
(function (StorageEnum) {
    StorageEnum["COOKIE"] = "cookie";
    StorageEnum["MEMORY"] = "memory";
    StorageEnum["WINDOW"] = "window";
    StorageEnum["SESSION"] = "session";
})(StorageEnum = exports.StorageEnum || (exports.StorageEnum = {}));
exports.parseStorageEnum = function (storage) {
    switch (storage) {
        case StorageEnum.COOKIE:
            return StorageEnum.COOKIE;
        case StorageEnum.MEMORY:
            return StorageEnum.MEMORY;
        case StorageEnum.WINDOW:
            return StorageEnum.WINDOW;
        case StorageEnum.SESSION:
            return StorageEnum.SESSION;
        default:
            throw new Error('Invalid or Unsupported Storage type ' + storage);
    }
};
//# sourceMappingURL=storage.enum.js.map